<template>
  <div class="ticker-stat gg-branding-supporting">
    <img v-if="imageName" :src="imageUrl" :class="imageName + '-image'" alt="">
    <div class="stat-container">
      <vue-odometer
        animation=""
        className="odometer gg-branding-supporting"
        format="(,ddd).dd"
        :value="stat"
      />
    </div>
    <span class="ml-2">{{this.label}}</span>
  </div>
</template>

<script>
import VueOdometer from 'v-odometer/src'

export default {
  name: 'TickerStat',
  components: {
    'vue-odometer': VueOdometer,
  },
  props: {
    imageName: String,
    label: {
      type: String,
      required: true,
    },
    stat: {
      type: Number,
      required: true,
    },
  },
  computed: {
    imageUrl () { return `https://s3.amazonaws.com/gg-day-of-giving/${this.$store.state.dog.name}/icons/${this.imageName}.svg`},
  }
}
</script>

<style scoped lang="scss">
.ticker-stat {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 1rem;
  flex-grow: 1;

  img {
    height: 10vh;
    width: 10vh;

    &.ribbon-image {
      margin-left: -2vh;
      margin-right: -2vh;
    }
  }

  span {
    text-transform: capitalize;
  }
}
</style>
